import { createContext, useContext } from 'react';

// Default user structure based on DB response
const defaultUser = {
  id: '',
  email: '',
  name: '',
  lastName: '',
  country: '',
  country_iso3: '',
  accessLevel: '',
  allowedCountries: [],
  allowedCountriesIso3: [],
  allowedSections: [],
  hasAccess: false,
  isApproved: false,
};

export const UserContext = createContext({
  user: defaultUser,
  setUser: () => {},
});

export const useUser = () => useContext(UserContext); 